export const defaultLocale = "en";

export const locales = [{
  code: "en",
  name: "English",
  dir: "ltr"
},
{
  code: "es",
  name: "Español",
  dir: "ltr"
},
];
